import DashboardPage from '@/pages/dashboard/dashboard-page';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_protected/')({
  component: DashboardPage,
});
